<div class="dialogform no-print {{largeBreakpoint}}" [class.internal]="internalPortal"  [formGroup]="form">

  <div class="grid-x grid-margin-x">
    <div class="cell {{largeBreakpoint}}-order-1">
      <h2 [innerHTML]="textkeyPrefix + '.dialog.headline' + textkeyPostfix | translate"></h2>
    </div>
    <div *ngIf="!hideimage" class="relative cell {{largeBreakpoint}}-6 {{largeBreakpoint}}-order-3 image-wrapper" [style.background-image]="'url(' +  (advisorImagePath | advisorImageUrl) + ')'">
      <div *ngIf="copyright" class="copyright" [innerHTML]="textkeyPrefix + copyright | translate"></div>
    </div>
    <div class="cell {{largeBreakpoint}}-order-2 teaser-wrapper">
      <p [innerHTML]="textkeyPrefix + '.dialog.teaser' + textkeyPostfix | translate"></p>
    </div>
    <div class="cell {{largeBreakpoint}}-6 list-wrapper {{largeBreakpoint}}-order-4" [innerHTML]="textkeyPrefix + '.dialog.liste' + textkeyPostfix | translate"></div>
  </div>

  <div *ngIf="result === null && !downloadUrl" class="form-wrapper">
    <div class="grid-x grid-margin-x">

      <div class="cell {{largeBreakpoint}}-order-1">
        <div role="alert" class="form-errors" *ngIf="error" [innerHTML]="(textkeyPrefix + '.dialogform.error.' + error) | translate" #formErrors></div>
      </div>

      <div class="cell checkbox" *ngIf="showCheckbox">
        <input type="checkbox" id="dialogform-terms" name="terms" value="1" formControlName="dialogform-terms">
        <label for="dialogform-terms" [innerHTML]="textkeyPrefix + '.dialogform.terms' | translate"></label>
      </div>

      <div class="cell {{mediumBreakpoint}}-4 {{largeBreakpoint}}-2" *ngIf="showName">
        <label for="dialogform-salutation">{{ textkeyPrefix + '.dialogform.salutation.label' | translate }} <span class="req" *ngIf="markMandatoryFields && mandatoryFields.indexOf('salutation') > -1">*</span></label>
        <div class="input-group">
          <select id="dialogform-salutation" name="salutation" formControlName="dialogform-salutation">
            <option value="">{{textkeyPrefix + '.dialogform.salutation.pleasechoose.label' | translate}}</option>
            <option *ngFor="let salutation of salutationOptions" [value]="salutation">{{textkeyPrefix + '.dialogform.salutation.' + salutation + '.label' | translate}}</option>
          </select>
        </div>
      </div>
      <div class="cell {{mediumBreakpoint}}-4 {{largeBreakpoint}}-5" *ngIf="showName">
        <label for="dialogform-firstname">{{ textkeyPrefix + '.dialogform.firstname.label' | translate }} <span class="req" *ngIf="markMandatoryFields && mandatoryFields.indexOf('firstname') > -1">*</span></label>
        <div class="input-group">
          <input type="text" class="input-group-field" id="dialogform-firstname" name="firstname" formControlName="dialogform-firstname" value="">
        </div>
      </div>
      <div class="cell {{mediumBreakpoint}}-4 {{largeBreakpoint}}-5" *ngIf="showName">
        <label for="dialogform-lastname">{{ textkeyPrefix + '.dialogform.lastname.label' | translate }} <span class="req" *ngIf="markMandatoryFields && mandatoryFields.indexOf('lastname') > -1">*</span></label>
        <div class="input-group">
          <input type="text" class="input-group-field" id="dialogform-lastname" name="lastname" formControlName="dialogform-lastname" value="">
        </div>
      </div>

      <div class="cell {{mediumBreakpoint}}-6">
        <label for="dialogform-email">{{ textkeyPrefix + '.dialogform.email.label' | translate }} <span class="req" *ngIf="markMandatoryFields">*</span></label>
        <div class="input-group" [class.error]="false">
          <input type="email" class="input-group-field" id="dialogform-email" name="email" formControlName="dialogform-email" value="" [required]="true" [placeholder]="textkeyPrefix + '.dialogform.email.placeholder' | translate">
        </div>
      </div>
      <div class="cell {{mediumBreakpoint}}-6 dialogform-button">
        <button class="button" [class.signal-cta]="internalPortal" [class.primary]="!internalPortal" (click)="submit()" [innerHTML]="textkeyPrefix + '.dialogform.button' | translate"></button>
      </div>
      <div class="cell datenschutz" *ngIf="!showCheckbox">
        <p [innerHTML]="textkeyPrefix + '.dialogform.datenschutz' | translate"></p>
      </div>
      <div class="cell" *ngIf="markMandatoryFields">
        <p [innerHTML]="textkeyPrefix + '.dialogform.mandatory_fields.text' | translate" class="mandatory-fields-text"></p>
      </div>
    </div>
  </div>
  <div class="grid-x form-wrapper" *ngIf="result !== null" #resultWrapper>
    <div class="cell">
      <h3 [innerHTML]="textkeyPrefix + '.dialogform.result.' + result + '.headline' | translate"></h3>
      <p [innerHTML]="textkeyPrefix + '.dialogform.result.' + result + '.text' | translate"></p>
    </div>
  </div>

  <a type="button" [href]="downloadUrl" *ngIf="downloadUrl" class="button download" [class.signal-cta]="internalPortal" [class.primary]="!internalPortal" target="_blank">
    <span [innerHTML]="textkeyPrefix + '.dialog.download' | translate"></span>
    &nbsp;<i class="icon-download"></i>
  </a>
</div>
